import { useState, useCallback } from 'react';

export interface useOrderlineCheckReturnType {
  checkedOrderlines: string[];
  onOrderlineCheck: (orderlineNumber: string) => void;
  initiateCheck: () => void;
}

export const useOrderlineCheck = (): useOrderlineCheckReturnType => {
  const [checkedOrderlines, setCheckedOrderlines] = useState<string[]>([]);

  const onOrderlineCheck = useCallback((orderlineNumber: string) => {
    setCheckedOrderlines((prev) => {
      if (prev.includes(orderlineNumber)) {
        return prev.filter((id) => id !== orderlineNumber);
      }
      return [...prev, orderlineNumber];
    });
  }, []);

  const initiateCheck = useCallback(() => {
    setCheckedOrderlines([]);
  }, []);

  return { checkedOrderlines, onOrderlineCheck, initiateCheck };
};
